import {v4 as uuid} from "uuid"

export default ({ code, price_rule_id, id, created_at, usage_count }) => ({
  created_at,
  price_rule_id,
  usage_count,
  code,
  id: id || uuid()
})
